import ApiService from './';
import { AddCompanyParams, AddProjectParams, AddRemoveClientParams, UpdateClientDetailsParams } from '../params/redux/client';

/**
 * @heading1: Client API service.
 * @paragraph: This module provides a set of methods to interact with the Client API.
 * It handles operations like Fetching client, add client, edit client etc.
 */

const ClientApi = {
    /**
     * @heading3: Fetch Clients
     * @paragraph: Sends a GET request to retrieve all Clients available for the user.
     * @param: {string} token - The user's authentication token.
     * @returns: {Promise<unknown[]>} - The response containing a list of all clients.
     * @separator:
     */
    fetchClients: (token: string) => {
        // Perform a GET request to fetch clients
        return ApiService.apiHit({
            url: 'clients',
            method: 'get',
            token
        });
    },

    /**
     * @heading3: fetch Client detail
     * @paragraph: Sends a POST request to fetch a client detail.
     * @param: {string} token - The user's authentication token, required for authorization.
     * @param: {number} client_id - The data containing the client id for the operation.
     * @returns: {Promise<unknown[]>} - A promise that resolves to the response containing the operation result.
     * @separator:
     */
    fetchClientDetail: (token: string, client_id: number) => {
        // Perform a Post request to fetch client detail endpoint with the token
        return ApiService.apiHit({
            url: 'client-details',
            method: 'post',
            token,
            data: {
                client_id
            },
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    createCompany: (token: string, data: AddCompanyParams) => {
        // Perform a Post request to fetch client detail endpoint with the token
        return ApiService.apiHit({
            url: 'create-manual-company',
            method: 'post',
            token,
            data,
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    createProject: (token: string, data: AddProjectParams) => {
        // Perform a Post request to fetch client detail endpoint with the token
        return ApiService.apiHit({
            url: 'create-manual-project',
            method: 'post',
            token,
            data,
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    addRemoveAssigneeOfClient: (token: string, data: AddRemoveClientParams) => {
        // Perform a Post request to fetch client detail endpoint with the token
        return ApiService.apiHit({
            url: 'add-remove-assignee-company',
            method: 'post',
            token,
            data,
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    updateClientDetails: (token: string, data: UpdateClientDetailsParams) => {
        // Perform a Post request to fetch client detail endpoint with the token
        return ApiService.apiHit({
            url: 'update-client-details',
            method: 'post',
            token,
            data,
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    remindThem: (token: string, client_id: number, type: 'Email' | 'Twilio') => {
        // Perform a Post request to fetch client detail endpoint with the token
        return ApiService.apiHit({
            url: 'remind-them',
            method: 'post',
            token,
            data: { client_id, type },
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    }
};

export default ClientApi;
